import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Layouts } from '../../app.component';
import {PropertyGroupViewComponent} from "./property-group-view.component";

const routes: Routes = [  {
    path : 'data-catalogue/feature/:featureId/property-group/:propertyGroupId',
    component : PropertyGroupViewComponent,
    data: { layout: Layouts.SecureLayout }
}
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PropertyGroupViewRoutingModule { }